export function Body({ children }) {
  return <div className="min-h-screen flex flex-col">{children}</div>;
}
